export default "__VITE_ASSET__52b8daea__"